/**
 * 移动端 rem 适配方案（仅在屏幕宽度 ≤ 768px 时启用）
 * 基准：设计稿 375px / 10 = 37.5px = 1rem
 * PC 端使用 px 布局，不受 rem 影响
 */
;(function flexible(window, document) {
  var docEl = document.documentElement
  var dpr = window.devicePixelRatio || 1
  var MOBILE_BREAKPOINT = 768 // PC/移动端分界线

  // 判断当前是否为移动端
  function isMobile() {
    return docEl.clientWidth <= MOBILE_BREAKPOINT
  }

  // 设置 body 字体大小
  function setBodyFontSize() {
    if (document.body) {
      document.body.style.fontSize = isMobile() ? 12 * dpr + 'px' : ''
    } else {
      document.addEventListener('DOMContentLoaded', setBodyFontSize)
    }
  }
  setBodyFontSize()

  // 移动端：1rem = viewWidth / 10；PC 端：恢复默认
  function setRemUnit() {
    if (isMobile()) {
      var rem = docEl.clientWidth / 10
      docEl.style.fontSize = rem + 'px'
    } else {
      docEl.style.fontSize = '' // PC 端恢复浏览器默认 font-size
    }
  }
  setRemUnit()

  // 窗口大小变化时重新计算
  window.addEventListener('resize', setRemUnit)
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) setRemUnit()
  })

  // 0.5px 边框支持检测
  if (dpr >= 2) {
    var fakeBody = document.createElement('body')
    var testElement = document.createElement('div')
    testElement.style.border = '.5px solid transparent'
    fakeBody.appendChild(testElement)
    docEl.appendChild(fakeBody)
    if (testElement.offsetHeight === 1) {
      docEl.classList.add('hairlines')
    }
    docEl.removeChild(fakeBody)
  }
})(window, document)
